import {
    Dialog, DialogTitle, IconButton, makeStyles, Typography, withMobileDialog,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import PropTypes from 'prop-types';
import React from 'react';

const styles = makeStyles(({ spacing, shadows }) => ({
    MuiDialogTitleRoot: {
        margin: 0,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: spacing(2),
        boxShadow: shadows[2],
    },
    bold: {
        fontWeight: 600,
    },
    closeButton: {
        // position: 'absolute',
        // right: spacing(1),
        // top: spacing(1),
        // marginRight: spacing(1),
        // color: palette.grey[500],
    },
}));

function RegularDialog(props) {
    const classes = styles();
    const {
        id, title, children, fullScreen, ...dialogProps
    } = props;

    return (
        <Dialog
            {...dialogProps}
            fullWidth
            fullScreen={fullScreen}
            aria-labelledby={id}
        >
            <DialogTitle
                disableTypography
                className={classes.MuiDialogTitleRoot}
            >

                <Typography variant="h6" className={classes.bold}>
                    {title}
                </Typography>

                <IconButton color="default" className={classes.closeButton} onClick={dialogProps.onClose}>
                    <CloseIcon fontSize="large" />
                </IconButton>
            </DialogTitle>

            {children}


        </Dialog>
    );
}

RegularDialog.defaultProps = {
    title: '',
};

RegularDialog.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.node,
};

export default withMobileDialog()(RegularDialog);
